import api from './index'
import request from '@/utils/request'

/**
 * @description 风控工单通知消息列表
 */
export function riskOperFlows (data) {
  return request({
    url: `${api.riskOperFlows}`,
    method: 'post',
    data
  })
}
/**
 * @description 风控工单通知设置成已读
 */
export function updateReadState (data) {
  return request({
    url: `${api.updateReadState}`,
    method: 'post',
    data
  })
}
/**
 * @description 推广活动通知列表
 */
export function activityNotify (params) {
  return request({
    url: `${api.activityNotify}`,
    method: 'get',
    params
  })
}
